const getCleanUsername = (username = '') =>
  username.startsWith('@') ? username?.replace('@', '') : username

export default getCleanUsername
